import { useState, useRef, TouchEvent, useEffect } from "react";

const useLongPress = (scrollElement?: string) => {
    const touchRef = useRef<any>(null);
    const scrollRef = useRef<boolean>(false);
    const [isLongPress, setIsLongPress] = useState<boolean>(false);
    const [touchPosition, setTouchPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

    const handleTouchStart = (event: TouchEvent<HTMLDivElement>) => {
        scrollRef.current = false;
        setIsLongPress(false);
        touchRef.current = setTimeout(() => {
            if (!scrollRef.current) {
                setIsLongPress(true);
                setTouchPosition({
                    x: event.touches[0].clientX,
                    y: event.touches[0].clientY
                });
            }
        }, 500);
    };

    const handleTouchEnd = () => {
        if (!isLongPress) clearTimeout(touchRef.current);
        scrollRef.current = false;
    };

    useEffect(() => {
        if (scrollElement) {
            const element = document.getElementById(scrollElement);
            if (element) {
                element.addEventListener("scroll", () => {
                    scrollRef.current = true;
                });
            }
        }

        return () => {
            if (scrollElement) {
                const element = document.getElementById(scrollElement);
                if (element) {
                    element.removeEventListener("scroll", () => {
                        scrollRef.current = true;
                    });
                }
            }
        };
    }, []);

    return {
        handleTouchStart,
        handleTouchEnd,
        isLongPress,
        setIsLongPress,
        touchPosition
    };
};

export default useLongPress;
